module.exports = __webpack_public_path__ + "resources/icon_44_share.78969f942c1dbd4a.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_share.png
// module id = 434
// module chunks = 0 1 2 3 4